import { z } from 'zod';

const GUID = z.guid();

/** Whether `value` is written as a GUID, the form of every id the server hands out. */
export const isGuid = (value: string): boolean => GUID.safeParse(value).success;
